import { z } from "zod";

const MODULES_KEY = "trellis-modules";

const moduleSchema = z.object({
  name: z.string(),
  settings: z
    .object({
      only: z.boolean().optional(),
    })
    .nullable()
    .optional(),
});
export type Module = z.infer<typeof moduleSchema>;

const modulesSchema = z.record(z.array(moduleSchema));
export type Modules = Partial<z.infer<typeof modulesSchema>>;

export const getModules = () => {
  const moduleStr = localStorage.getItem(MODULES_KEY);
  if (moduleStr) {
    const parsedModules = JSON.parse(moduleStr);
    const validatedModules = modulesSchema.safeParse(parsedModules);
    if (validatedModules.success) {
      return validatedModules.data;
    }
  }
  return {};
};

export const setModules = (modules: Modules) => {
  localStorage.setItem(MODULES_KEY, JSON.stringify(modules));
};
